import { View } from 'react-native';

import { cn } from '@/components/ui/cn';

import { Check } from './Check';

export function PriceTick({ accent }: { accent?: boolean }) {
  return (
    <View
      className={cn(
        'h-[18px] w-[18px] items-center justify-center rounded-md',
        accent ? 'bg-signal' : 'bg-well',
      )}
    >
      <Check tone={accent ? 'on-signal' : 'foreground-secondary'} />
    </View>
  );
}
